const filterListModalFilterEquip = {
  text: 'FILTROS',
  clear: 'limpar filtros'
};

export default filterListModalFilterEquip;
